type JsonableThing = object | string | number | boolean | null
type JsonableValue = JsonableThing | JsonableThing[]

export const deserialize_querystring = (querystring: string, warn?: boolean) => {
	const url_params = new URLSearchParams(querystring)
	const output: { [key: string]: JsonableValue } = {}

	url_params.forEach((json_value, key) => {
		try {
			output[key] = JSON.parse(json_value) as JsonableValue
		} catch (err) {
			if (warn) {
				console.warn(`Wasn't able to parse`, json_value)
			} else {
				throw err
			}
		}
	})

	return output
}

export const deserialize_from_address_bar = () => {
	const querystring = document.location.search

	return deserialize_querystring(querystring, true)
}


export const serialize_to_querystring = (data_to_serialize: { [key: string]: JsonableValue }) => {
	const query_string = Object.entries(data_to_serialize).filter(
		([ , value ]) => value !== undefined
	).map(
		([ key, value ]) => `${ key }=${ encodeURIComponent(JSON.stringify(value)) }`
	).join(`&`)

	return query_string
}

export const serialize_to_address_bar = (data_to_serialize: { [key: string]: JsonableValue }) => {
	const existing_query_string_data = deserialize_from_address_bar()

	const query_string = serialize_to_querystring({ ...existing_query_string_data, ...data_to_serialize })

	history.replaceState(data_to_serialize, ``, query_string ? `?` + query_string : `.`)
}
